export default __webpack_public_path__ + "img/beneficios-bg-card-2.5d0862b6.png";